import script from "./AccountInfoView.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountInfoView.vue?vue&type=script&setup=true&lang=js"

import "./AccountInfoView.vue?vue&type=style&index=0&id=969b9d18&scoped=true&lang=css"

import exportComponent from "../../../consumer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-969b9d18"]])

export default __exports__